import {
  AnchorHTMLAttributes,
  ComponentType,
  createContext,
  useContext,
} from "react";

export type AffiliateAnalyticsPayload = {
  item_name?: string | null;
  item_id?: string | null;
  price?: number | null;
  discount?: number | null;
  item_brand?: string | null;
  item_category?: string | null;
  item_category2?: string | null;
  item_category3?: string | null;
  item_list_name?: string | null;
  index?: number | null;
  item_list_id?: string | null;
  location_id?: string | null;
  item_variant?: string | null;
  affiliation?: string | null;
  /** CMS block name (`product` for product block variants). */
  block_name?: string | null;
};

/** Props that the affiliate link components will receive */
export type AffiliateLinkProps = {
  analyticsPayload?: AffiliateAnalyticsPayload;
  includeClickAnalytics?: false | "auto" | true;
  includeViewAnalytics?: false | "auto" | true;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export type AffiliateContextType = {
  /** Allow consumers of `duet-ui` to set their own affiliate link component */
  linkComponent?: ComponentType<AffiliateLinkProps>;
  /** Allow consumers of `duet-ui` to mark an url as an affiliate (optionally for performance improvements) */
  isAffiliate?: (url: string) => boolean;
};

const AffiliateContext = createContext<AffiliateContextType | null>(null);

export const useAffiliateContext = (): AffiliateContextType | null => {
  const context = useContext(AffiliateContext);
  return context;
};

export default AffiliateContext;
